import { Col, Modal, Row } from "react-bootstrap";
import Button from "../../../common/components/Button";
import Textfield from "../../../common/components/Textfiled";
import { useEffect, useState } from "react";
import moment from "moment";
import { GoQuestion } from "react-icons/go";

function toCapitalize(value) {
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

function formatDate(dateString) {
  return moment(dateString).format("YYYY-MM-DD");
}

function ModalUpdateSurvey({
  show,
  toggleShow,
  survey,
  onUpdateSurvey,
  setSurvey,
}) {
  const [defaultQuestions, setDefaultQuestions] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e;
    setSurvey((prev) => ({
      ...prev,
      respuestas: prev.respuestas.map((res) =>
        res.id_pregunta.toString() === name
          ? {
              ...res,
              traduccion_respuesta: toCapitalize(value),
              respuesta: value,
            }
          : res
      ),
    }));
  };

  const getLabel = (id_pregunta) => {
    if (id_pregunta === -1) return "Kilometraje";
    if (id_pregunta === -2) return "Placa";
    if (id_pregunta === -3) return "Cedula";
    if (id_pregunta === -4) return "Nombre";
    return `Pregunta ${id_pregunta}`;
  };

  useEffect(() => {
    if (survey) {
      setDefaultQuestions(
        survey?.respuestas
          .filter((res) => res.id_pregunta <= 0)
          .map((res) => ({
            ...res,
            label: getLabel(res.id_pregunta),
          }))
      );
    }
  }, [survey]);

  return (
    <Modal
      show={show}
      onHide={toggleShow}
      size="xl"
      centered
      backdrop="static"
      dialogClassName="modal-w90"
    >
      <Modal.Header closeButton className="border-bottom pb-3">
        <Modal.Title className="w-100 text-center">
          <h2 className="h4 fw-bold mb-1">Actualizar Encuesta</h2>
          <p className="text-muted small mb-0">
            Celular: <strong>{survey?.celular}</strong> | Fecha:{" "}
            <strong>{formatDate(survey?.fecha_actualizacion)}</strong>
          </p>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        className="pt-4 pb-5"
        style={{ maxHeight: "75vh", overflowY: "auto" }}
      >
        <form>
          {/* Información básica (defaultQuestions) */}
          {defaultQuestions.length > 0 && (
            <div className="mb-5">
              <h6 className="text-primary fw-semibold mb-4 border-bottom pb-2">
                Información Básica
              </h6>
              <Row xs={1} md={2} lg={3} className="g-4">
                {defaultQuestions.map((res) => (
                  <Col key={res.id}>
                    <div className="bg-light rounded-3 p-4 shadow-sm h-100">
                      <Textfield
                        label={res.label}
                        value={res.traduccion_respuesta || res.respuesta || ""}
                        name={res.id_pregunta}
                        onChange={handleChange}
                        placeholder={res.placeholder ?? "Ingrese aquí..."}
                      />
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          )}

          {/* Preguntas de la encuesta */}
          <div>
            <h6 className="text-primary fw-semibold mb-4 border-bottom pb-2">
              Preguntas de la Encuesta
            </h6>
            <Row xs={1} md={1} lg={2} className="g-4">
              {survey?.respuestas
                .filter((res) => res.id_pregunta > 0)
                .map((res, index) => (
                  <Col key={res.id}>
                    <div
                      className="card border-0 shadow-sm h-auto"
                      style={{
                        backgroundColor: "#f8f9fa",
                        borderLeft:
                          res.tipo_respuesta === "SiNo"
                            ? "4px solid #0d6efd"
                            : "4px solid #6c757d",
                      }}
                    >
                      <div className="card-body p-4">
                        {/* Número y pregunta */}
                        <div className="d-flex align-items-start mb-3">
                          <span className="badge bg-primary rounded-pill me-3 mt-1">
                            <GoQuestion />
                          </span>
                          <div className="flex-grow-1">
                            <label className="form-label fw-semibold text-dark mb-2">
                              {res.pregunta + "-" + res.id_pregunta}
                            </label>
                          </div>
                        </div>

                        {/* Campo de respuesta */}
                        <Textfield
                          value={res.traduccion_respuesta || ""}
                          name={res.id_pregunta}
                          onChange={handleChange}
                          placeholder="Escribe tu respuesta aquí..."
                          error={!res.traduccion_respuesta?.trim()}
                          disabled={!res.celular}
                        />
                      </div>
                    </div>
                  </Col>
                ))}
            </Row>
          </div>
        </form>
      </Modal.Body>

      <Modal.Footer className="border-top pt-4 bg-light">
        <div className="d-flex justify-content-between w-100 gap-2">
          <Button color="#6c757d" onClick={toggleShow} size="lg">
            Cancelar
          </Button>
          <Button
            onClick={() => {
              onUpdateSurvey(survey);
              toggleShow();
            }}
          >
            Guardar Cambios
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalUpdateSurvey;
